import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../../utils/queryParams.js";

export const SET_LOADING = "saga/marketing/SET_LOADING";
export const SET_PREV_PAGE_FILTERS = "saga/marketing/SET_PREV_PAGE_FILTERS";

export const FETCH_CURRENT_USER = "saga/marketing/FETCH_CURRENT_USER";
export const FETCH_CURRENT_USER_SUCCESS = "saga/marketing/FETCH_CURRENT_USER_SUCCESS";

export const UPDATE_ALL_DATA = "saga/marketing/UPDATE_ALL_DATA";
export const UPDATE_ALL_DATA_SUCCESS = "saga/marketing/UPDATE_ALL_DATA_SUCCESS";

export const FETCH_MARKETING_TOTALS_SUCCESS = "saga/marketing/FETCH_MARKETING_TOTALS_SUCCESS";

export const FETCH_MARKETING_REFERRAL_SUCCESS = "saga/marketing/FETCH_MARKETING_REFERRAL_SUCCESS";

export const FETCH_MARKETING_PROFILE_RETENTION_SUCCESS =
  "saga/marketing/FETCH_PROFILE_RETENTION_SUCCESS";
export const FETCH_MARKETING_INTROS_RETAINED_SUCCESS =
  "saga/marketing/FETCH_MARKETING_INTROS_RETAINED_SUCCESS";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateAllData: createAction(UPDATE_ALL_DATA)
};

export default function* watchStars() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_ALL_DATA, updateAllData);
}

export function* getCurrentUserData({ payload }) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });
  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: payload.user });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date: payload.date };

  let allSagas = [
    getTotalsData(params),
    getReferralsData(params),
    getProfileRetentionData(params),
    getIntrosRetained(params)
  ];
  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* updateAllData({ payload }) {
  // Get user data first. Once we confirm we have user data pass to other sagas and call them.
  yield put({ type: SET_LOADING, payload: true });
  yield put({
    type: SET_PREV_PAGE_FILTERS,
    payload: { prevDate: payload.date }
  });

  const { short_url, organization_id } = yield select((state) => state.commonReducer.commonProps);
  let params = { short_url, organization_id, date: payload.date };

  let allSagas = [
    getTotalsData(params),
    getReferralsData(params),
    getProfileRetentionData(params),
    getIntrosRetained(params)
  ];

  try {
    yield all(allSagas);
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* getTotalsData(params) {
  try {
    const totalsResponse = yield call(axios.get, queryParams.apiVersion + "marketing/totals", {
      params
    });
    yield put({ type: FETCH_MARKETING_TOTALS_SUCCESS, payload: totalsResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getReferralsData(params) {
  try {
    const referralResponse = yield call(
      axios.get,
      queryParams.apiVersion + "marketing/referral_by_source",
      { params }
    );
    yield put({ type: FETCH_MARKETING_REFERRAL_SUCCESS, payload: referralResponse.data });
  } catch (error) {
    console.error(error);
  }
}

export function* getProfileRetentionData(params) {
  try {
    const profileRetentionResponse = yield call(
      axios.get,
      queryParams.apiVersion + "marketing/profile_retention",
      { params }
    );

    yield put({
      type: FETCH_MARKETING_PROFILE_RETENTION_SUCCESS,
      payload: profileRetentionResponse.data
    });
  } catch (error) {
    console.error(error);
  }
}

export function* getIntrosRetained(params) {
  try {
    const profileRetentionResponse = yield call(
      axios.get,
      queryParams.apiVersion + "retention/totals",
      { params }
    );
    yield put({
      type: FETCH_MARKETING_INTROS_RETAINED_SUCCESS,
      payload: profileRetentionResponse.data
    });
  } catch (error) {
    console.error(error);
  }
}
